import React from "react";
import PdfViewer from "./PdfViewer";
import PDF from "./TT_Tagdyrlar_Taitalasy_Book2_2021_sc_watermark.pdf";
import "./App.css";

const App = () => (
  <div className="content">
    <h1>Кітапты Оқу</h1>
    <PdfViewer pdf={PDF} />
  </div>
);

export default App;
